import React, { useState, createContext, useContext, useEffect } from 'react';
import "./LanguageChange.css";

// Create language context
const LanguageContext = createContext();

// Language context provider
export function LanguageChange({ children }) {
  // Initialize with localStorage value or default
  const [currentLang, setCurrentLang] = useState(() => {
    try {
      // Try to get saved language from localStorage
      const savedLang = localStorage.getItem('preferredLanguage');
      // Check if it's one of our supported languages
      if (savedLang && ['en', 'es', 'hi'].includes(savedLang)) {
        return savedLang;
      }
    } catch (error) {
      console.error("Error accessing localStorage:", error);
    }
    return 'en'; // Default to English if no saved preference or error
  });
  
  // Save language preference to localStorage when it changes
  useEffect(() => {
    try {
      localStorage.setItem('preferredLanguage', currentLang);
      console.log("Language set in localStorage:", currentLang);
    } catch (error) {
      console.error("Error saving to localStorage:", error);
    }
  }, [currentLang]);
  
  // Object with all translations
  const translations = {
    en: {
      topBarText: "Save money with LocalCableDeals! We're here to help you find the best Internet and TV provider according to your needs and budget.",
      howWeEarn: "How we earn",
      switchLanguage: "Change Language:"
    },
    es: {
      topBarText: "¡Ahorra dinero con LocalCableDeals! Estamos aquí para ayudarte a encontrar el mejor proveedor de Internet y TV según tus necesidades y presupuesto.",
      howWeEarn: "¿Cómo ganamos?",
      switchLanguage: "Cambiar Idioma:"
    },
    hi: {
      topBarText: "LocalCableDeals के साथ पैसे बचाएं! हम आपकी जरूरतों और बजट के अनुसार सर्वोत्तम इंटरनेट और टीवी प्रदाता खोजने में आपकी मदद करने के लिए यहां हैं।",
      howWeEarn: "हम कैसे कमाते हैं",
      switchLanguage: "भाषा बदलें:"
    }
  };
  
  // Memorize value to prevent unnecessary re-renders
  const value = React.useMemo(() => {
    return { currentLang, setCurrentLang, translations };
  }, [currentLang]);
  
  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}

// Custom hook to use the language context
export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageChange provider');
  }
  return context;
}